module.exports = __webpack_public_path__ + "static/media/bbq_thomas.87eabb2c.mp4";